<template>
  <v-dialog width="500" v-model="showBranchForm">
    <v-card>
      <v-card-title class="secondary white--text">
        <span> {{ editMode ? "Update" : "Add" }} Branch </span>

        <v-spacer></v-spacer>

        <v-btn icon @click="resetForm(), (showBranchForm = false)">
          <v-icon class="white--text">mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="pt-2">
        <v-form ref="branchForm" v-if="showBranchForm" v-model="isValid">
          <v-row class="my-0">
            <v-col cols="12" class="Form-Columns">
              <InputField
                label="Branch Code *"
                required
                :rules="[
                  (val) => !!val || 'Branch Code is Required!',
                  (val) =>
                    !$globals.numbersOnlyRegExp.test(val) ||
                    'Invalid Branch Code!',
                ]"
                hide-details="auto"
                :clearable="true"
                v-model="branchDetails.branch_code"
                :error-messages="formErrors.branch_code"
                @input="delete formErrors.branch_code"
              />
            </v-col>
            <v-col cols="12" class="Form-Columns">
              <InputField
                label="Branch Name *"
                required
                :rules="[(val) => !!val || 'Branch Name is Required!']"
                :clearable="true"
                hide-details="auto"
                v-model="branchDetails.branch_name"
                :error-messages="formErrors.branch_name"
                @input="delete formErrors.branch_name"
              />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-divider></v-divider>
      <v-card-actions class="justify-end">
        <v-btn
          color="primary"
          depressed
          :disabled="!isValid"
          @click="submitForm"
        >
          Submit
        </v-btn>

        <v-btn
          class="ml-3"
          color="secondary"
          v-if="!editMode"
          depressed
          @click="resetForm"
        >
          Reset
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import InputField from "@/components/FormBaseComponents/InputField.vue";
import MultiSelect from "@/components/FormBaseComponents/MultiSelect.vue";

export default {
  components: {
    InputField,
    MultiSelect,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    editMode: {
      type: Boolean,
      default: false,
    },
    editBranchID: {
      type: [Number, null],
      default: null,
    },
  },
  watch: {
    value(val) {
      if (val) {
        if (this.editMode) {
          this.getBranchObject(this.editBranchID);
        }
      } else {
        this.resetForm();
      }
    },
  },
  computed: {
    showBranchForm: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      isValid: true,
      isTextInput: false,
      formErrors: {},
      branchDetails: {},
    };
  },
  methods: {
    submitForm() {
      this.$bus.$emit("showLoader", true);
      if (!this.editMode) {
        this.branchDetails = {
          ...this.branchDetails,
        };
        this.$api.branch
          .addBranch(this.branchDetails)
          .then((res) => {
            this.$bus.$emit("showLoader", false);
            this.$bus.$emit("showToastMessage", {
              message: "Transporter User Map added successfully!",
              color: "success",
            });
            this.resetForm();
            this.showBranchForm = false;
            this.$emit("refreshList");
          })
          .catch((err) => {
            this.$bus.$emit("showLoader", false);
            this.$bus.$emit("showToastMessage", {
              message: `${
                err.data && err.data.non_field_errors
                  ? err.data.non_field_errors.join()
                  : "Couldn't add Branch"
              }`,
              color: "error",
            });
            this.formErrors = err.data;
          });
      } else {
        this.$api.branch
          .updateBranch({
            id: this.branchDetails.id,
            data: this.branchDetails,
          })
          .then((res) => {
            this.$bus.$emit("showLoader", false);
            this.$bus.$emit("showToastMessage", {
              message: "Branch updated successfully!",
              color: "success",
            });
            this.resetForm();
            this.showBranchForm = false;
            this.$emit("refreshList");
          })
          .catch((err) => {
            this.$bus.$emit("showLoader", false);
            this.$bus.$emit("showToastMessage", {
              message: `${
                err.data && err.data.non_field_errors
                  ? err.data.non_field_errors.join()
                  : "Couldn't update Branch"
              }`,
              color: "error",
            });

            this.formErrors = err.data;
          });
      }
    },

    resetForm() {
      if (this.$refs.branchForm) {
        this.$refs.branchForm.reset();
      }
      this.branchDetails = {};
    },

    getBranchObject(id) {
      this.$bus.$emit("showLoader", true);
      this.$api.branch
        .getBranchObject(id)
        .then((res) => {
          this.$bus.$emit("showLoader", false);
          this.branchDetails = res.data;
        })
        .catch((err) => {
          console.error(err);
          this.$bus.$emit("showLoader", false);
        });
    },
  },
};
</script>
